exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre[data-v-97cdc46c]{background:#f5f5f5;padding:10px;border-radius:4px;overflow:auto}button[data-v-97cdc46c]{border:none;border-radius:4px;cursor:pointer;font-size:14px}button[data-v-97cdc46c]:hover{opacity:.8}", ""]);

// exports
